import React, { useEffect } from 'react'
import { connect } from 'react-redux';
import moment from 'moment';

import Table from '../../components/Table';
import { getUsers, getCustomers, updateSearchParams } from '../../store/actions/adminDashboard';
import { IListParams, IUser , UserColumns, UserTypes, ICustomer } from '../../shared/models/adminModels';

const customerColumns = [
    {
        Header: 'Name',
        accessor: UserColumns.CustomerName,
    },
    {
        Header: 'Email',
        accessor: UserColumns.Email,
    },
    {
        Header: 'Status',
        accessor: UserColumns.Active,
        Cell: (props: any) => (
                <div className="active-status-wrp d-flex">
                   <span className={ (props.cell.value ? 'active-status' : 'inactive-status') + ' mr-2'}></span>
                   {props.cell.value ? 'Active' : 'Inactive'} 
                </div>
        )
    },
];

const userColumns = [
    {
        Header: 'Name',
        accessor: UserColumns.UserName,
    },
    {
        Header: 'Email',
        accessor: UserColumns.Email,
    },
    {
        Header: 'Last Login',
        accessor: UserColumns.LastLoginDateTime,
        Cell: (props: any) => props.cell.value ? moment(props.cell.value*1000).format('DD/MM/YYYY hh:mm a') : '-'
    },
    {
        Header: 'Status',
        accessor: UserColumns.Active,
        Cell: (props: any) => (
                <div className="active-status-wrp d-flex">
                    <span className={ (props.cell.value ? 'active-status' : 'inactive-status') + ' mr-2'}></span>
                    {props.cell.value ? 'Active' : 'Inactive'} 
                </div>
        )
    },
];

interface IProps {
    getUsers: (param: IListParams) => void,
    getCustomers: (param: IListParams) => void,
    customerList: any,
    userList: any,
    isLoading: boolean,
    updateSearchParams: (params: IListParams, userType: UserTypes) => void
}

const AdminDashboard = (props: IProps) => {
    const { 
        totalPages: userTotalPages, 
        data: userData, 
        pageSize :userPageSize, 
        orderBy: userOrderBy,
        currentPage: userCurrentPage,
        searchParameter: userSearchParameter,
        sortType: userSortType
    } = props.userList;

    const { 
        totalPages: customerTotalPages, 
        data: customerData, 
        pageSize :customerPageSize, 
        orderBy: customerOrderBy,
        currentPage: customerCurrentPage,
        searchParameter: customerSearchParameter,
        sortType: customerSortType
    } = props.customerList;
   
    let userList: any = [];
    let customerList: any = [];

    // get usersList
    const getUserList = async (saerchParams: IListParams) => {
        await props.getUsers(saerchParams);
    }

    // get customerList
    const getCustomerList = async (saerchParams: IListParams) => {
        await props.getCustomers(saerchParams);
    }

    if (userData.length) {
        userList = props.userList.data.map((user: IUser) => {
            return {
                [UserColumns.UserName] : user.userName,
                [UserColumns.Email]: user.email,
                [UserColumns.Active]: user.active,
                [UserColumns.LastLoginDateTime]: user.lastLoginDateTime
            }
        });
    }

    if (customerData.length) {
        customerList = props.customerList.data.map((customer: ICustomer) => {
            return {
                [UserColumns.CustomerName] : customer.customerName,
                [UserColumns.Email]: customer.email,
                [UserColumns.Active]: customer.active
            }
        });
    }

    useEffect(() => {
        getUserList({
            currentPage: userCurrentPage,
            pageSize: userPageSize,
            orderBy: userOrderBy,
            searchParameter: userSearchParameter,
            sortType: userSortType
        });

        getCustomerList({
            currentPage: customerCurrentPage,
            pageSize: customerPageSize,
            orderBy: customerOrderBy,
            searchParameter: customerSearchParameter,
            sortType: customerSortType
        });
    }, []);

    return (
        <div className="container-fluid">
            <div className="page-header">
                <h1>Admin</h1>
                {/* <a className="back" href="">
                    <FontAwesomeIcon icon={faChevronLeft} /> Back</a> */}
            </div>
            <div className="page-content">
                <div className="row">
                    <div className="col-xl-6">
                        <div className="info-title box-shaddow box-padding border-btm-blue mb-5">
                            <h3>Users</h3>
                        </div>
                        <div className="info-box box-shaddow box-padding">
                            <div className="table-responsive">
                                <Table 
                                    columns={userColumns} 
                                    data={userList}
                                    fetchData={getUserList}
                                    totalPages={userTotalPages}
                                    isLoading={props.isLoading}
                                    currentPage={userCurrentPage}
                                    pageSize={userPageSize}
                                    orderBy={userOrderBy}
                                    searchParameter={userSearchParameter}
                                    sortType={userSortType}
                                    userType={UserTypes.USER}
                                    updateSearchParams={props.updateSearchParams}
                                    firstHeadClass='f-col'
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6">
                        <div className="info-title box-shaddow box-padding border-btm-blue mb-5">
                            <h3>Customers</h3>
                        </div>
                        <div className="info-box box-shaddow box-padding">
                            <div className="table-responsive">
                                <Table
                                    columns={customerColumns} 
                                    data={customerList}
                                    fetchData={getCustomerList}
                                    totalPages={customerTotalPages}
                                    isLoading={props.isLoading}
                                    currentPage={customerCurrentPage}
                                    pageSize={customerPageSize}
                                    orderBy={customerOrderBy}
                                    searchParameter={customerSearchParameter}
                                    sortType={customerSortType}
                                    userType={UserTypes.CUSTOMER}
                                    updateSearchParams={props.updateSearchParams}
                                    firstHeadClass='f-col'
                                />
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state: any) => {
    return ({
        customerList: state.adminDashboardReducer.customerList,
        userList: state.adminDashboardReducer.userList,
        isLoading: state.common.isLoading
    })
};

const mapDispatchToProps = (dispatch: any) => ({
    getUsers: (params: IListParams) => dispatch(getUsers(params)),
    getCustomers: (params: IListParams) => dispatch(getCustomers(params)),
    updateSearchParams: (params: IListParams, userType: UserTypes) => dispatch(updateSearchParams(params, userType))
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminDashboard)
